import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var compressImage = normalize.compressImage(function (args) {
  args && typeof args.quality === 'number' && (args.quality = args.quality * 33);
  return tt.compressImage(args);
}, CONTAINER_NAME.BYTE);
export default compressImage;